export const DETAILED = "detailed";
export const SIMPLE = "simple";
